import { makeActionCreator } from '../../utils/actionsUtils';
import { HIDE_BANNER, SHOW_BANNER } from './constants';

export const showBanner = makeActionCreator(SHOW_BANNER, 'bannerType', 'bannerProps');
export const hideBanner = makeActionCreator(HIDE_BANNER);



// WEBPACK FOOTER //
// ./src/services/banner/actions.js